import withStyles, { StyleRules } from '@material-ui/core/styles/withStyles';
import CardMedia from '@material-ui/core/CardMedia';

const styles = (theme): StyleRules => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    zIndex: 10,
    borderRadius: theme.shape.borderRadius,
    paddingTop: '100%',
  },
});

export default withStyles(styles)(CardMedia);
